/** GraphFrame parser: GraphElement + `title`/`autoshrink_*`/`drag_margin`/`tint_color*`. */
import { unquoteString } from '../../../../parser/utils';
import { parseOptionalBool, parseOptionalInt } from '../../../../parser/valueParsers';
import { parseColorOrUndefined } from '../../../../utils/colorParser';
import { parseGraphElement } from '../graphelement/parser';
export function parseGraphFrame(heading, properties) {
    const result = { ...parseGraphElement(heading, properties) };
    if (properties.title !== undefined)
        result.title = unquoteString(properties.title);
    result.autoshrinkEnabled = parseOptionalBool(properties.autoshrink_enabled);
    result.autoshrinkMargin = parseOptionalInt(properties.autoshrink_margin);
    result.dragMargin = parseOptionalInt(properties.drag_margin);
    result.tintColorEnabled = parseOptionalBool(properties.tint_color_enabled);
    result.tintColor = parseColorOrUndefined(properties.tint_color);
    return result;
}
//# sourceMappingURL=parser.js.map